// Shared password-strength policy, mirrored from the backend's
// `assert_strong_password` (models.py): at least 10 characters, plus one
// each of lowercase, uppercase, digit, and special character. All five are
// required for a password to be accepted — this module just gives the UI a
// live breakdown of which ones are (or aren't yet) satisfied.

export const PASSWORD_MIN_LENGTH = 10;

export const getPasswordChecks = (password = '') => ({
  length: password.length >= PASSWORD_MIN_LENGTH,
  lower: /[a-z]/.test(password),
  upper: /[A-Z]/.test(password),
  digit: /\d/.test(password),
  special: /[^A-Za-z0-9]/.test(password),
});

export const getPasswordScore = (password = '') =>
  Object.values(getPasswordChecks(password)).filter(Boolean).length; // 0-5

export const isPasswordStrongEnough = (password = '') => getPasswordScore(password) === 5;

const LEVELS = [
  { max: 2, label: 'Weak', barClass: 'bg-rose-500', textClass: 'text-rose-400' },
  { max: 3, label: 'Fair', barClass: 'bg-amber-500', textClass: 'text-amber-400' },
  { max: 4, label: 'Good', barClass: 'bg-amber-300', textClass: 'text-amber-300' },
  { max: 5, label: 'Strong', barClass: 'bg-emerald-500', textClass: 'text-emerald-400' },
];

export const getPasswordLevel = (score) => LEVELS.find((l) => score <= l.max) || LEVELS[LEVELS.length - 1];

export const PASSWORD_REQUIREMENTS = [
  { key: 'length', label: `At least ${PASSWORD_MIN_LENGTH} characters` },
  { key: 'upper', label: 'One uppercase letter' },
  { key: 'lower', label: 'One lowercase letter' },
  { key: 'digit', label: 'One number' },
  { key: 'special', label: 'One special character' },
];
